export default "__VITE_ASSET__CWyx00Du__"